import api from "./api";

// Serviço administrativo de releases (super admin)
// Todas as funções retornam Promises que resolvem para data ou lançam erro tratado externo.

export const listReleases = async ({ offset = 0, limit = 20, status } = {}) => {
  const params = { offset, limit };
  if (status) params.status = status;
  const { data } = await api.get("/releases", { params });
  return data;
};

export const createRelease = async ({ version, titulo }) => {
  const { data } = await api.post("/releases", { version, titulo });
  return data;
};

export const getRelease = async (id) => {
  const { data } = await api.get(`/releases/${id}`);
  return data;
};

export const updateRelease = async (id, payload) => {
  const { data } = await api.put(`/releases/${id}`, payload);
  return data;
};

export const publishRelease = async (id) => {
  const { data } = await api.post(`/releases/${id}/publish`);
  return data;
};

export const unpublishRelease = async (id) => {
  const { data } = await api.post(`/releases/${id}/unpublish`);
  return data;
};

export const addItem = async (releaseId, { titulo, categoria, descricaoMarkdown, anexo }) => {
  const form = new FormData();
  form.append("titulo", titulo || "");
  form.append("categoria", categoria || "feature");
  form.append("descricaoMarkdown", descricaoMarkdown || "");
  if (anexo) form.append("anexo", anexo);
  const { data } = await api.post(`/releases/${releaseId}/items`, form, {
    headers: { "Content-Type": "multipart/form-data" }
  });
  return data;
};

export const updateItem = async (itemId, { titulo, categoria, descricaoMarkdown, anexo }) => {
  const form = new FormData();
  if (titulo != null) form.append("titulo", titulo);
  if (categoria != null) form.append("categoria", categoria);
  if (descricaoMarkdown != null) form.append("descricaoMarkdown", descricaoMarkdown);
  if (anexo) form.append("anexo", anexo);
  const { data } = await api.put(`/releases/items/${itemId}`, form, {
    headers: { "Content-Type": "multipart/form-data" }
  });
  return data;
};

// ---- Multi-attachments helpers ----
export const listItemAttachments = async (itemId) => {
  const { data } = await api.get(`/releases/items/${itemId}/attachments`);
  return data;
};

export const addItemAttachments = async (itemId, files = []) => {
  const form = new FormData();
  files.forEach(f => form.append("anexos", f));
  const { data } = await api.post(`/releases/items/${itemId}/attachments`, form, {
    headers: { "Content-Type": "multipart/form-data" }
  });
  return data;
};

export const deleteItemAttachment = async (itemId, attachmentId) => {
  const { data } = await api.delete(`/releases/items/${itemId}/attachments/${attachmentId}`);
  return data;
};

export const deleteItem = async (itemId) => {
  const { data } = await api.delete(`/releases/items/${itemId}`);
  return data;
};

export const listRoadmap = async ({ light = true } = {}) => {
  const params = {};
  if (light) params.light = 1;
  const { data } = await api.get("/roadmap", { params });
  return data.itens || [];
};

export const getRoadmapItem = async (id) => {
  const { data } = await api.get(`/roadmap/${id}`); // Endpoint opcional futuro
  return data;
};

export const createRoadmapItem = async ({ titulo, descricaoMarkdown, status = "planned", prioridade }) => {
  const { data } = await api.post("/roadmap", { titulo, descricaoMarkdown, status, prioridade });
  return data;
};

export const updateRoadmapItem = async (id, payload) => {
  const { data } = await api.put(`/roadmap/${id}`, payload);
  return data;
};

export const deleteRoadmapItem = async (id) => {
  const { data } = await api.delete(`/roadmap/${id}`);
  return data;
};

export const deleteRelease = async (id) => {
  const { data } = await api.delete(`/releases/${id}`);
  return data;
};

export const forceDeleteRelease = async (id) => {
  const { data } = await api.delete(`/releases/${id}/force`);
  return data;
};

// ===== Export/Import ZIP =====
export const exportZip = async ({ mode = "all", count = 3 } = {}) => {
  const params = { mode };
  if (mode === "last") params.count = count;
  const response = await api.get(`/releases/export-zip`, {
    params,
    responseType: "blob"
  });
  // Tenta extrair filename do header Content-Disposition
  const cd = response.headers && (response.headers["content-disposition"] || response.headers["Content-Disposition"]) || "";
  let filename = `changelog-export.zip`;
  const m = /filename\*=UTF-8''([^;]+)|filename="?([^";]+)"?/i.exec(cd);
  if (m) filename = decodeURIComponent(m[1] || m[2]);
  return { blob: response.data, filename };
};

export const importZip = async (file) => {
  const form = new FormData();
  form.append("file", file);
  const { data } = await api.post(`/releases/import-zip`, form, {
    headers: { "Content-Type": "multipart/form-data" }
  });
  return data;
};

// Export default agregando
export default {
  listReleases,
  createRelease,
  getRelease,
  updateRelease,
  publishRelease,
  unpublishRelease,
  addItem,
  updateItem,
  deleteItem,
  deleteRelease,
  forceDeleteRelease,
  listRoadmap,
  getRoadmapItem,
  createRoadmapItem,
  updateRoadmapItem,
  deleteRoadmapItem,
  exportZip,
  importZip
};
